export enum WorkflowDisplayMode {
  CLONE = 'clone',
  CREATE = 'create',
  EDIT = 'edit',
  PREVIEW = 'preview',
}
